// @flow

import * as React from 'react';

import type { DialogStateProps } from '@gandi/ui';

import { useSuggestedList } from '../modules/hook';

import { AvailableRow } from './components/AvailableRow';
import { useDomainBundle } from './modules';

type Props = { phasesDialogState: DialogStateProps };

export function HighLightedSuggestion({
  phasesDialogState,
}: Props): null | React.MixedElement {
  const { highlightedResult } = useSuggestedList();

  const { bundle } = useDomainBundle();
  const hasBundle = bundle?.content.includes(highlightedResult || '');

  if (!highlightedResult) return null;

  return (
    <AvailableRow
      fqdn={highlightedResult}
      hasBundle={hasBundle}
      phasesDialogState={phasesDialogState}
    />
  );
}
